import {ViewPersonalConfig} from "../../@type";
import {PersonalViewLocation} from "../@types";
import {ViewType} from "../../../../gd/const/views/view-type";
import MainMenu_MyTask from "../../../../../layout/menu/sections/custom-view/my-tasks";

export const MY_TASKS_LIST_CONFIG : ViewPersonalConfig = {
    type                : ViewType.MY_TASKS_LIST,
    name                : 'My Tasks',
    icon                : 'i5-tasks',       // 'i5-my-tasks',
    iconSvg             : 'isvg-view-my-tasks',
    url                 : 'my-tasks',
    description         : 'All tasks related to you',
    defaultLocation     : PersonalViewLocation.HOME,
    // mainMenuComponent   : MainMenu_MyTask            // Removed for new top design with Tabs
    // mainMenuComponent   : null
}
